<template>
  <v-layout justify-center class="white">
    <v-flex xs12 sm10 md10 justify-center>
      <v-layout>
        <v-flex xm12 sm4 class="title text-xs-center text-sm-left align-center">
        </v-flex>
        <v-flex xm12 md4 class="text-sm-center">
          <span class="headline">Email History</span><br />
        </v-flex>
      </v-layout>

      <v-card>
        <v-card-text>
          <vue-good-table
            ref="my-table"
            styleClass="vgt-table striped bordered"
            :max-height=this.height
            :fixed-header="true"
            :isLoading=this.isTableLoading
            :columns="columns"
            :rows="rows"
            :search-options="{
              enabled: true
            }">
            <template slot="loadingContent">
              <div>
                <v-progress-circular
                  :size="50"
                  :width="7"
                  color="blue"
                  indeterminate
                ></v-progress-circular>
              </div>
            </template>
            <div slot="table-actions-bottom">
              <span class="body-2" style="padding-left: 20px;">Number of records: {{ totalCount }}</span>
            </div>
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'who'">
                <v-layout align-center justify-start row fill-height>
                  <v-flex xs12>
                    {{ props.row.User.fullName }}
                  </v-flex>
                </v-layout>
              </span>
            </template>
          </vue-good-table>
        </v-card-text>
      </v-card>
    </v-flex>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import { VueGoodTable } from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
import moment from 'moment'

export default {
  props: ['item'],

  components: {
    VueGoodTable
  },

  data () {
    return {
      myId: this.$store.state.user.id,
      page: 'Email List',
      currentYear: 0,
      loading: false,
      isTableLoading: false,
      isMounted: false,
      toggle_multiple: ['chair', 'assist', 'excel'],
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      editedIndex: -1,
      height: 0,
      columns: [
        {
          label: 'To',
          field: 'note',
          thClass: 'text-center',
          html: true
        },
        {
          label: 'Subject',
          field: 'subject',
          thClass: 'text-left',
          html: true
        },
        {
          label: 'Date',
          field: 'createdAt',
          thClass: 'text-center',
          html: true
        }
      ],
      committeeHeader: {},
      rows: []
    }
  },

  created () {
    this.currentYear = this.$store.state.currentYear

    this.loading = true

    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    this.getEmail()

    this.loading = false
  },

  mounted () {
    this.isMounted = true
  },

  computed: {
    totalCount () {
      if (!this.isMounted) {
        return
      }

      return this.$refs['my-table'].totalRowCount
    }
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    handleResize () {
      const height = window.innerHeight - 600
      this.height = height + 'px'
    },

    async getEmail () {
      try {
        const response = await Api().get('emails/' + this.item.VendorContacts[0].email)
        const history = response.data

        for (let i in history) {
          let item = {}
          let dDate = moment(history[i].createdAt).format('MM/DD/YYYY - hh:mm A')
          item.note = history[i].to
          item.subject = history[i].subject
          item.createdAt = dDate
          this.rows.push(item)
        }

        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.vgt-fixed-header {
  z-index: 1;
}

.vgt-fixed-header th:last-child {
    /* Offset for the scrollbar, you may have to adjust this */
    width: calc(100% + 17px) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/vendor/EmailList.vue